import React, { Component } from "react";
import CodeMirror from "react-codemirror";
import "./code.css";

require("codemirror/mode/javascript/javascript");
require("codemirror/mode/xml/xml");
require("codemirror/mode/markdown/markdown");

//https://github.com/JedWatson/react-codemirror

class Code extends Component {
  constructor(props) {
    super(props);
    this.options = {
      mode: this.props.lang == null ? "javascript" : this.props.lang,
      lineWrapping: false,
      lineNumbers: false,
      styleActiveLine: false,
      matchBrackets: true,
      readOnly: true
    };
  }
  render() {
    return (
      <div>
        {this.props.title != null ? <p>{this.props.title}</p> : <span />}
        <CodeMirror value={this.props.children} options={this.options} />
      </div>
    );
  }
}

export default Code;
